import { Store } from "./appStore";
const store = new Store();
export { store, Store };



// WEBPACK FOOTER //
// ./src/publics/store/index.ts